import React from "react";
import { ReactComponent as BlueBackArrow } from "../assets/images/Icons/blue-back-arrow.svg";
import { ReactComponent as Email } from "../assets/images/Icons/email.svg";
import { ReactComponent as Password } from "../assets/images/Icons/password.svg";
import { ReactComponent as CheckMark } from "../assets/images/Icons/check.svg";
import { ReactComponent as Notification } from "../assets/images/Icons/notification.svg";
import { ReactComponent as DropdownArrow } from "../assets/images/Icons/dropdown-arrow.svg";
import { ReactComponent as ToggleMenu } from "../assets/images/Icons/toggle-menu.svg";
import { ReactComponent as Cross } from "../assets/images/Icons/cross.svg";
import { ReactComponent as Pin } from "../assets/images/Icons/pin.svg";
import { ReactComponent as Dollar } from "../assets/images/Icons/dollar.svg";
import { ReactComponent as Location } from "../assets/images/Icons/location.svg";
import { ReactComponent as RightTickFilled } from "../assets/images/Icons/right-tick-filled.svg";
import { ReactComponent as ErrorFilled } from "../assets/images/Icons/error-filled.svg";
import { ReactComponent as Calender } from "../assets/images/Icons/calender.svg";
import { ReactComponent as AddCircle } from "../assets/images/Icons/add-circle.svg";
import { ReactComponent as ThreeDots } from "../assets/images/Icons/three-dots.svg";
import { ReactComponent as Edit } from "../assets/images/Icons/edit.svg";
import { ReactComponent as Delete } from "../assets/images/Icons/delete.svg";
import { ReactComponent as View } from "../assets/images/Icons/view.svg";
import { ReactComponent as CheckCircle } from "../assets/images/Icons/check-circle.svg";
import { ReactComponent as Plus } from "../assets/images/Icons/plus.svg";
import { ReactComponent as Link } from "../assets/images/Icons/link.svg";
import { ReactComponent as Message } from "../assets/images/Icons/message.svg";
import { ReactComponent as DownArrow } from "../assets/images/Icons/down-arrow.svg";
import { ReactComponent as ArrowLeft } from "../assets/images/Icons/arrow-left.svg";
import { ReactComponent as AddForm } from "../assets/images/Icons/add-form.svg";
import { ReactComponent as SendLink } from "../assets/images/Icons/send-link.svg";
import { ReactComponent as ResendLink } from "../assets/images/Icons/resend-link.svg";
import { ReactComponent as LinkedIn } from "../assets/images/Icons/linkedin.svg";
import { ReactComponent as NotAllowed } from "../assets/images/Icons/not-allowed.svg";
import { ReactComponent as Download } from "../assets/images/Icons/download.svg";
import { ReactComponent as History } from "../assets/images/Icons/history.svg";
import { ReactComponent as Search } from "../assets/images/admin-icon/search.svg";
import { ReactComponent as SelectArrow } from "../assets/images/Icons/select-arrow.svg";
import { ReactComponent as Reactivate } from "../assets/images/Icons/reactivate.svg";
import { ReactComponent as Permission } from "../assets/images/Icons/permission.svg";
import { ReactComponent as Resend } from "../assets/images/Icons/resend.svg";

const SVGIcon = ({ icon, size = 24, className = "" }) => {
  const Icons = {
    blue_back_arrow: (
      <BlueBackArrow className={className} width={size} height={size} />
    ),
    email: <Email className={className} width={size} height={size} />,
    password: <Password className={className} width={size} height={size} />,
    check_mark: <CheckMark className={className} width={size} height={size} />,
    notification: (
      <Notification className={className} width={size} height={size} />
    ),
    dropdown_arrow: (
      <DropdownArrow className={className} width={size} height={size} />
    ),
    toggle_menu: (
      <ToggleMenu className={className} width={size} height={size} />
    ),
    cross: <Cross className={className} width={size} height={size} />,
    pin: <Pin className={className} width={size} height={size} />,
    dollar: <Dollar className={className} width={size} height={size} />,
    location: <Location className={className} width={size} height={size} />,
    right_tick_filled: (
      <RightTickFilled className={className} width={size} height={size} />
    ),
    error_filled: (
      <ErrorFilled className={className} width={size} height={size} />
    ),
    calender: <Calender className={className} width={size} height={size} />,
    add_circle: <AddCircle className={className} width={size} height={size} />,
    three_dots: <ThreeDots className={className} width={size} height={size} />,
    edit: <Edit className={className} width={size} height={size} />,
    delete: <Delete className={className} width={size} height={size} />,
    view: <View className={className} width={size} height={size} />,
    check_circle: (
      <CheckCircle className={className} width={size} height={size} />
    ),
    plus: <Plus className={className} width={size} height={size} />,
    link: <Link className={className} width={size} height={size} />,
    message: <Message className={className} width={size} height={size} />,
    down_arrow: <DownArrow className={className} width={size} height={size} />,
    arrow_left: <ArrowLeft className={className} width={size} height={size} />,
    add_form: <AddForm className={className} width={size} height={size} />,
    send_link: <SendLink className={className} width={size} height={size} />,
    resend_link: (
      <ResendLink className={className} width={size} height={size} />
    ),
    linkedIn: <LinkedIn className={className} width={size} height={size} />,
    not_allowed: (
      <NotAllowed className={className} width={size} height={size} />
    ),
    reactivate: <Reactivate className={className} width={size} height={size} />,
    download: <Download className={className} width={size} height={size} />,
    history: <History className={className} width={size} height={size} />,
    search: <Search className={className} width={size} height={size} />,
    select_arrow: (
      <SelectArrow className={className} width={size} height={size} />
    ),
    permission: <Permission className={className} width={size} height={size} />,
    resend: <Resend className={className} width={size} height={size} />,
  };
  return Icons[icon];
};

export default SVGIcon;
